export default __webpack_public_path__ + "media/flags/ml-4a96b708.svg";